import { apiRequest } from './client';

export const fetchEnterpriseSummary = () => apiRequest('/enterprise/reports/summary');
export const fetchAuditLogs = (query = {}) => apiRequest('/enterprise/audit', { query });
export const fetchNotifications = (query = {}) => apiRequest('/enterprise/notifications', { query });
export const markNotificationRead = (id) => apiRequest(`/enterprise/notifications/${encodeURIComponent(id)}/read`, { method: 'PUT' });
export const markAllNotificationsRead = () => apiRequest('/enterprise/notifications/read-all', { method: 'PUT' });
export const clearAllNotifications = () => apiRequest('/enterprise/notifications', { method: 'DELETE' });
export const deleteNotification = (id) => apiRequest(`/enterprise/notifications/${encodeURIComponent(id)}`, { method: 'DELETE' });
export const bootstrapEnterprise = () => apiRequest('/enterprise/bootstrap', { method: 'POST', body: {} });
